import { updateObject } from '@/shared/utility';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  user: {},
  userLoading: false,
  userError: null,
  tags: [],
  tagsLoaded: false,
};

// User
const getUserStart = state =>
  updateObject(state, {
    userLoading: true,
  });

const getUserSuccess = (state, action) => {
  return updateObject(state, {
    user: action.user,
    userLoading: false,
  });
};

const getUserFail = (state, action) =>
  updateObject(state, {
    userLoading: false,
    userError: action.error,
  });

const getUserTagsSuccess = (state, action) =>
  updateObject(state, {
    tags: action.tags,
    tagsLoaded: true,
  });

const getUserTagsError = state =>
  updateObject(state, {
    tagsLoaded: true,
  });

const clearUser = state => updateObject(state, initialState);

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_USER_START:
      return getUserStart(state, action);
    case actionTypes.GET_USER_SUCCESS:
      return getUserSuccess(state, action);
    case actionTypes.GET_USER_FAIL:
      return getUserFail(state, action);
    case actionTypes.GET_USER_TAGS_SUCCESS:
      return getUserTagsSuccess(state, action);
    case actionTypes.GET_USER_TAGS_ERROR:
      return getUserTagsError(state);
    case actionTypes.SET_USER_EMAIL:
      return {
        ...state,
        user: {
          ...state.user,
          Email: action.email,
        },
      };
    case actionTypes.SET_USER:
      return getUserSuccess(state, action);
    case actionTypes.CLEAR_USER:
      return clearUser(state, action);
    default:
      return state;
  }
};

export default userReducer;
